import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { MyConfigOrganization } from '../../../../../models/myConfig';
import { ParkingVM } from '../../../../../models/parkingsite.model';
import { OrgParkingEditComponent } from '../org-parking-edit/org-parking-edit.component';
import { MatDialog } from '@angular/material/dialog';
import { BackOfficeService } from '../../../../../services/backoffice.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-org-parking-list',
  standalone: false,
  templateUrl: './org-parking-list.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './org-parking-list.component.css'
})
export class OrgParkingListComponent {
  @Input() organization: MyConfigOrganization;
  @Input() isLoading: boolean = false;
  @Output() incrementRequests: EventEmitter<void> = new EventEmitter<void>();
  @Output() decrementRequests: EventEmitter<void> = new EventEmitter<void>();
  parkingVMs: ParkingVM[] = [];
  private componentDestroyed$ = new Subject<void>();

  constructor(
    private dialog: MatDialog,
    private backOfficeService: BackOfficeService,

  ) { }

  ngOnInit(): void {
    this.getParkings();
  }

  ngOnDestroy(): void {
    this.componentDestroyed$.next();
    this.componentDestroyed$.complete();
  }

  getParkings() {
    this.incrementRequests.emit();
    this.backOfficeService
      .getOrganizationParkings(this.organization.organizationId)
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe(parkingVMs => {
        this.parkingVMs = parkingVMs.map((parkingVM: ParkingVM) => {
          const parseFeature = (feature: string | any) => {
            if (!feature) return feature;
            if (typeof feature !== 'string') return feature;

            let decoded = feature.replace(/&quot;/g, '"');
            decoded = decoded.replace(/\\u0022/g, '"');

            return decoded;
          };

          return {
            ...parkingVM,
            feature1: parseFeature(parkingVM.feature1),
            feature2: parseFeature(parkingVM.feature2),
            feature3: parseFeature(parkingVM.feature3),
            feature4: parseFeature(parkingVM.feature4),
            feature5: parseFeature(parkingVM.feature5),
            feature6: parseFeature(parkingVM.feature6),
            parkingFeatures: this.getFeatures(parkingVM)
          }
        });
        this.decrementRequests.emit();
      });
  }

  getFeatures(parkingVM: ParkingVM) {
    const parseFeature = (feature: string | any) => {
      if (!feature) return null;
      if (typeof feature !== 'string') return feature;

      let decoded = feature.replace(/&quot;/g, '"');
      decoded = decoded.replace(/\\u0022/g, '"');

      return decoded;
    };

    var features = [];
    parkingVM.feature1 ? features.push(parseFeature(parkingVM.feature1)) : null;
    parkingVM.feature2 ? features.push(parseFeature(parkingVM.feature2)) : null;
    parkingVM.feature3 ? features.push(parseFeature(parkingVM.feature3)) : null;
    parkingVM.feature4 ? features.push(parseFeature(parkingVM.feature4)) : null;
    parkingVM.feature5 ? features.push(parseFeature(parkingVM.feature5)) : null;
    parkingVM.feature6 ? features.push(parseFeature(parkingVM.feature6)) : null;
    return features;
  }

  editParking(parking: ParkingVM): void {
    console.log(parking)
    const dialogRef = this.dialog.open(OrgParkingEditComponent, {
      width: '800px',
      data: {
        parking,
        // organization: this.organizationId
      }
    });
    dialogRef.afterOpened().subscribe(() => {
      dialogRef.componentInstance.saveChangesEvent.subscribe(updatedParking => {
        if (updatedParking) {
          this.updateParking(updatedParking);
        }
      });
    });
    dialogRef.afterClosed().subscribe(() => {
      dialogRef.componentInstance.saveChangesEvent.unsubscribe();
    });
  }

  updateParking(updatedParking: ParkingVM) {
    updatedParking.parkingFeatures = this.getFeatures(updatedParking);
    const indexOrg = this.organization.config.parkings.findIndex(p =>
      p.parkingId === updatedParking.parkingId
    );
    this.organization.config.parkings[indexOrg] = updatedParking;
    const indexVM = this.parkingVMs.findIndex(p =>
      p.parkingId === updatedParking.parkingId
    );
    this.parkingVMs[indexVM] = updatedParking;
  }
}
